<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex justify-content-between catalogo-text"
          >
            Perfil
            <router-link :to="{ name: 'NuevoPerfil' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Perfil
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por perfiles..."
                />
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditarPerfilPermisos',
                      params: { id: item.id }
                    }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Perfil"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el perfil {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Perfil</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deletePerfil(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "rol", label: "Perfil", _style: "width:80%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Perfiles",

  data() {
    return {
      items: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.isLoading = true;
    const roles = [
      this.$store.dispatch("customRolHTTP", {
        limit: 50,
        page: 1
      })
    ];
    Promise.all(roles)
      .then(([items]) => {
        this.items = items.data;
        this.pages = items.paginate.last_page;
        this.page = items.paginate.current_page;
      })
      .catch(rej => console.log(rej.message))
      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(i =>
        i.rol.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customRolHTTP", {
          limit: 50,
          page: 1,
          filter: {
            where: [
              {
                field: "rol",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customRolHTTP", {
          limit: 50,
          page: event,
          filter: {
            where: [
              {
                field: "rol",
                operator: "like",
                value: `%${this.filter.toUpperCase()}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)
        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.rol,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deletePerfil(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customRolDeleteHTTP", {
          rol_id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
</style>
